export default "{\n    \"hide\": \"Hide\",\n    \"show\": \"Show\"\n}\n"